function download(fileName: string, content: Blob, type: string) {
  const a = document.createElement('a');
  a.download = fileName;
  a.href = URL.createObjectURL(content);
  a.dataset.downloadurl = [`${content.type}`, fileName, a.href].join(':');
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(a.href);
  }, 1500);
}

export function downloadTypedStringContent(fileName: string, content: string, type = 'text/plain') {
  const blob = new Blob([content], { type: `${type};charset=utf-8` });
  download(fileName, blob, type);
}
